<template>
  <div :class="jel_getClassObject(content)">
    <div class="container p-0">
      <div
        v-if="isSpinnerVisible"
        id="spinner"
        class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
      >
        <b-spinner :label="$t('chargement')"></b-spinner>
      </div>

      <div class="row">
        <div class="col text-left">
          <b-link
            v-bind="jel_getLienBinding(content.lienRetour)"
            class="d-none d-md-block lien-retour btnVide p-0 mb-2"
          >
            <svg-icon
              icon-name="fleche-gauche"
              className="icone-fleche mySvg"
              :class="content.lien.cssIcone"
            ></svg-icon>
            <span class="graphik_semibold lien-retour pl-0 pt-sm-n1">{{
              content.libLienRetour
            }}</span>
          </b-link>

          <Titre
            :content="{
              type: 'grandTitre',
              titre: content.titre,
              classeCSS: 'text-left mb-2',
            }"
          >
          </Titre>

          <b-img-lazy
            v-if="content.image"
            :src="jel_getFichierSrc(content.image)"
            class="mx-md-0 mx-auto d-block mb-2"
          />

          <!-- Affichage des erreurs systèmes -->
          <div v-if="isErreurServeur">
            <MessageMel
              v-show="contentMessageMel.message"
              :content="contentMessageMel"
              class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
            ></MessageMel>

            <!-- En cas d'erreur système, on appelle la même méthode du début du processus au mounted (verifierStatutClient) -->
            <button
              class="btn btn-primaire d-block mx-md-0 mx-auto px-4 mt-2"
              @click="erreurServerReessayer()"
            >
              {{ content.libReessayer }}
            </button>
          </div>
          <!-- Aucune erreur système (cas normal)  -->
          <div v-else>
            <!-- CLIENT GUEST -->
            <div v-show="statutClient === 'guest'">
              <Paragraphe
                :content="{
                  richText: content.txtClientsGuest,
                  classeCSS: 'pb-1',
                }"
              ></Paragraphe>
              <button
                class="btn btn-primaire d-block mx-md-0 mx-auto px-4"
                @click="redirectToValidation()"
              >
                {{ content.libPoursuivreInscription }}
              </button>
            </div>

            <!-- CLIENT JOUEUR -->
            <div v-show="statutClient === 'joueur'">
              <!-- Si le client a déjà une carte associée -->
              <div v-if="numeroCarte">
                <!-- Modale de confirmation du choix de retrait de la carte -->
                <b-modal
                  id="retrait-carte"
                  body-class="py-5 px-4 compteClair"
                  centered
                  hide-header-close
                  no-hide-backdrop
                  no-close-on-backdrop
                  no-close-on-esc
                  hide-footer
                  hide-header
                >
                  <div class="contenu-modal-retrait">
                    <Titre
                      :content="{
                        type: 'sousTitre',
                        titre: jel_replaceTokens(content.titreModaleRetraitCarte),
                        classeCSS: 'titre-modal mb-2 pt-1',
                      }"
                    >
                    </Titre>

                    <Paragraphe
                      :content="{
                        richText: content.txtModaleRetraitCarte,
                        classeCSS: 'contenu-texte-modal pb-2',
                      }"
                    ></Paragraphe>

                    <button
                      class="btn-modal-confirm btn btn-primaire d-block mx-auto px-8 mb-2"
                      @click="confirmerRetraitCarte()"
                    >
                      {{ content.libConfirmerRetrait }}
                    </button>

                    <button
                      class="btn-modal-cancel d-block mx-auto px-4 my-0"
                      @click="fermerModaleRetraitCarte()"
                    >
                      {{ content.libAnnulerRetrait }}
                    </button>
                  </div>
                </b-modal>

                <MessageMel
                  v-show="contentMessageMel.message"
                  :content="contentMessageMel"
                  class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
                ></MessageMel>

                <!-- afficher le numéro de carte et bouton pour la retirer sauf si la carte est devenue inactive après l'association -->
                <div v-if="erreurObtenirCarteInactive">
                  <div class="numero-carte-inactive">
                    <p class="d-inline-block mr-1" v-html="content.txtNumeroDeMembre"></p>
                    <div class="d-inline-block" v-html="numeroCarte"></div>
                  </div>
                </div>
                <!-- carte active -->
                <div v-else>
                  <Paragraphe
                    :content="{
                      richText: content.txtClientsMembreInfoSupplementaire,
                    }"
                  ></Paragraphe>

                  <!-- Section points Statut Casino -->
                  <div v-if="point">
                    <Titre
                      :content="{
                        type: 'titre',
                        titre: content.titreSectionPoints,
                        classeCSS: 'text-left pt-4',
                      }"
                    >
                    </Titre>
                    <div class="col-sm-10 p-0 section-points">
                      <div v-if="point.lastUpdate" class="note">
                        {{ $t('messageComponent.enDateDu', lastUpdateDateTime) }}*
                      </div>
                      <div class="mt-1 p-3 zone-pts">
                        <b-row>
                          <b-col><div v-html="content.libPointsEnLigne" /></b-col>
                          <b-col
                            ><b-row>
                              <b-col class="col-12 text-right absolute-bottom">{{
                                Math.floor(point.online).toLocaleString($i18n.locale)
                              }}</b-col>
                              <!-- TODO: Retirer (2023-11-02) -->
                              <!-- <b-col class="col-5 pl-1 pr-0">{{
                                $tc('messageComponent.point', point.online)
                              }}</b-col> -->
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col><div v-html="content.libPointsEnEtablissements" /></b-col>
                          <b-col>
                            <b-row>
                              <b-col class="col-12 text-right absolute-bottom">{{
                                Math.floor(point.landBased).toLocaleString($i18n.locale)
                              }}</b-col>
                              <!-- TODO: Retirer (2023-11-02) -->
                              <!-- <b-col class="col-5 pl-1 pr-0">{{
                                $tc('messageComponent.point', point.landBased)
                              }}</b-col> -->
                            </b-row></b-col
                          >
                        </b-row>
                        <b-row class="graphik_semibold pt-1">
                          <b-col><div v-html="content.libPointsTotaux" /></b-col>
                          <b-col>
                            <b-row>
                              <b-col class="col-12 text-right absolute-bottom">{{
                                Math.floor(point.total).toLocaleString($i18n.locale)
                              }}</b-col>
                              <!-- TODO: Retirer (2023-11-02) -->
                              <!-- <b-col class="col-5 pl-1 pr-0">{{
                                $tc('messageComponent.point', point.total)
                              }}</b-col> -->
                            </b-row></b-col
                          >
                        </b-row>
                      </div>
                      <p class="px-0 note mt-1" v-html="content.txtMajPoints" />

                      <div v-if="point.total === 0">
                        <Hyperlien :content="contentLienAucunPoint"></Hyperlien>
                      </div>

                      <!-- Statut de membre -->
                      <Titre
                        :content="{
                          type: 'titre',
                          titre: content.titreSectionStatut,
                          classeCSS: 'text-left pb-1 pt-4',
                        }"
                      >
                      </Titre>
                      <div class="section-statut">
                        <p class="txt-statut graphik_semibold">{{ point.status }}</p>
                        <img
                          v-if="imageStatut"
                          class="mb-3"
                          :src="imageStatut"
                          :alt="$t('messageComponent.altStatut') + ' ' + point.status"
                        />
                        <Hyperlien :content="contentLienAideStatuts"></Hyperlien>
                      </div>
                    </div>
                  </div>

                  <div
                    class="mt-4 d-inline-block mr-1 graphik_medium note"
                    v-html="content.txtNumeroDeMembre"
                  ></div>
                  <div class="mb-2 mr-2 d-inline-block note" v-html="numeroCarte"></div>
                  <a class="retraitCarte graphik_medium note" @click="ouvrirModaleRetraitCarte()">{{
                    content.libLienRetraitCarte
                  }}</a>
                </div>
              </div>
              <div v-else>
                <div v-if="consentementClient">
                  <!-- Le client a donné son consentement -->
                  <!-- Pas de numéro de carte, il faut le saisir -->
                  <div v-if="appariementValide">
                    <div v-if="erreurApparimentSuccesMaisCarteInactive">
                      <!-- Client est valide et apparié et sa carte est devenue inactive -->
                      <Paragraphe
                        :content="{
                          richText: content.txtPageErreurCarteInactive,
                        }"
                      ></Paragraphe>
                    </div>
                    <!-- Autre cas pour ObtenirCarte -->
                    <div v-else>
                      <div v-if="erreurObtenirCarte">
                        <!-- Ici le client est valide et apparié mais il y a une erreur avec la carte (autre que carte inactive gérer précédement) -->
                        <!-- On affiche donc le message d'erreur et rien d'autre -->
                        <MessageMel
                          v-show="contentMessageMel.message"
                          :content="contentMessageMel"
                          class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
                        ></MessageMel>
                      </div>
                      <div v-else>
                        <!-- client appariement valide et aucune erreur avec ObtenirCarte -->
                        <Titre
                          :content="{
                            type: 'titre',
                            titre: content.titreSaisieCarte,
                            classeCSS: 'text-left pt-1 pb-1',
                          }"
                        >
                        </Titre>

                        <Paragraphe
                          :content="{
                            richText: content.txtSaisieCarte,
                            classeCSS: 'p-0',
                          }"
                        ></Paragraphe>

                        <b-form-group :label="content.libNumeroCarte" label-for="numeroCarte">
                          <b-form-input
                            :id="content.idHTML ? content.idHTML : 'numeroCarte'"
                            v-model="inputNumeroCarte"
                            v-remove-extra-spaces
                            trim
                            type="text"
                            maxlength="10"
                            autocomplete="off"
                            class="mr-1"
                            :class="
                              !inputIsValid && inputNumeroCarte != '' ? 'is-invalid' : 'valid'
                            "
                            @focus="viderMessageMel()"
                            @blur="validateFormInput()"
                          />

                          <span class="fin-numero-carte">-XXX (X)</span>
                          <div class="exemple-numero-carte mt-1">Ex. <b>12 345</b>-001 (1)</div>

                          <!-- Ce lien affiche le menu d'aide pour trouver le numéro de joueur du client -->
                          <Hyperlien class="lien-aide" :content="contentLienAideNumero"></Hyperlien>
                        </b-form-group>

                        <MessageMel
                          v-show="contentMessageMel.message"
                          :content="contentMessageMel"
                          class="mt-n2 mb-0 mx-0 mx-md-auto p-0"
                        ></MessageMel>

                        <Paragraphe
                          :content="{
                            richText: content.txtLegalSaisieCarte,
                          }"
                          class="texte-legal"
                        ></Paragraphe>

                        <button
                          :disabled="!inputNumeroCarte.length"
                          class="btn-sauvegarde btn btn-primaire d-block mx-md-0 mx-auto px-4"
                          @click="sauvegarderCarte(inputNumeroCarte)"
                        >
                          {{ content.libBoutonSauvegarder }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <!-- contenu pour clients non appariés RCU page d'erreur générique -->
                    <Paragraphe
                      :content="{
                        richText: content.txtPageErreurGenerique,
                        classeCSS: 'p-0',
                      }"
                    ></Paragraphe>
                  </div>
                  <!-- fin contenu clients non appariés RCU -->
                </div>
                <div v-else>
                  <!-- Le client doit donner son consentement pour continuer -->
                  <!-- MessageMel pour le retrait de la carte doit maintenant s'afficher sur la page de consetement -->

                  <!-- la validation retraitCarte permet d'afficher ce MessageMel dans un seul cas précis (lors du retrait de la carte) et rien d'autre -->
                  <MessageMel
                    v-show="contentMessageMel.message && retraitCarte"
                    :content="contentMessageMel"
                    class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
                  ></MessageMel>

                  <Paragraphe
                    :content="{
                      richText: content.txtConsentement,
                    }"
                  ></Paragraphe>

                  <Hyperlien :content="contentLienEnSavoirPlus"></Hyperlien>

                  <Titre
                    :content="{
                      type: 'titre',
                      titre: content.titreConsentement,
                      classeCSS: 'text-left pt-1 pb-1',
                    }"
                  >
                  </Titre>

                  <Paragraphe
                    :content="{
                      richText: content.txtConsentementSupplementaire,
                      classeCSS: 'pb-2',
                    }"
                  ></Paragraphe>

                  <button
                    class="btn btn-primaire d-block mx-md-0 mx-auto px-4"
                    @click="consentir()"
                  >
                    {{ content.libBoutonConsentement }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import store from '@/store';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import session from '@/services/api/compte/session';
import MessageMel from '@/components/base/MessageMel';
import MessageHelpers from '@/helpers/MessageHelpers';
import Hyperlien from '@/components/base/Hyperlien';
import Titre from '@/components/base/Titre';
import Paragraphe from '@/components/base/Paragraphe';
import { playerPaymentProfileStatus } from '@/helpers/ProfileHelpers';
import { returnToHome } from '@/helpers/RouteHelpers';
import { inMgnl } from '@/helpers/AppHelpers';

export default {
  name: 'CompteCasinoPrivilegesAppariement',
  components: {
    MessageMel,
    Hyperlien,
    Titre,
    Paragraphe,
  },
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          enDateDu: 'En date du {date}',
          point: 'point | point | points',
          altStatut: 'Statut de membre :',
        },
      },
      en: {
        messageComponent: {
          enDateDu: 'Last updated on {date}',
          point: 'point | point | points',
          altStatut: 'Status Level:',
        },
      },
    },
  },
  data() {
    return {
      isSpinnerVisible: true,
      inputNumeroCarte: '',
      inputIsValid: true,
      statutClient: '',
      consentementClient: false,
      appariementValide: false,
      erreurObtenirCarte: false,
      erreurObtenirCarteInactive: false,
      retraitCarte: false,
      erreurApparimentSuccesMaisCarteInactive: false,
      compteurErreurs: 0,
      NOMBRE_MAX_ERREURS: 3,
      message: null,
      contentMessageMel: {
        message: null,
      },
      isErreurServeur: false,
    };
  },
  computed: {
    ...mapGetters({
      point: 'casinoPrivileges/getPoint',
    }),
    numeroCarte: {
      get() {
        return store.getters['casinoPrivileges/getNumeroCarte'];
      },
      set(value) {
        this.inputNumeroCarte = value;
      },
    },
    imageStatut() {
      let image = null;
      this.content.statut['@nodes'].forEach((statut) => {
        if (this.content.statut[statut].titre === this.point.status)
          image = this.jel_getFichierSrc(this.content.statut[statut].image);
      });
      return image;
    },
    lastUpdateDateTime() {
      const d = new Date(this.point.lastUpdate);
      let date = d.toLocaleDateString(this.$i18n.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      if (d.getDate() === 1 && this.$i18n.locale == 'fr') {
        date = `1er${date.slice(1)}`;
      }

      let time = d.toLocaleTimeString(this.$i18n.locale, { timeStyle: 'short' }).replace(/^0+/, '');
      if (this.$i18n.locale == 'en') {
        time = time.replace('AM', 'a.m.').replace('PM', 'p.m.');
      } else {
        time = time.replace(':', ' h ');
      }

      return { date, time };
    },
    contentLienEnSavoirPlus() {
      return {
        texte: this.content.libLienEnSavoirPlusConsentement,
        type: 'lienSecondaire',
        lien: this.content.lienConsentement,
        classeCSS: 'text-center text-md-left m-0 pb-2',
      };
    },
    contentLienAideNumero() {
      if (!this.content.libTexteAideNumero) {
        return null;
      }
      return {
        texte: this.content.libTexteAideNumero,
        type: 'aide',
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionNumeroJoueur,
        },
      };
    },
    contentLienAideStatuts() {
      return {
        texte: this.content.libLienEnSavoirPlusStatuts,
        type: 'aide',
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionEnSavoirPlusStatuts,
        },
      };
    },
    contentLienAucunPoint() {
      return {
        texte: this.content.libLienAucunPoint,
        type: 'aide',
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionAucunPoint,
        },
      };
    },
  },
  mounted() {
    // Afficher le spinner au chargement de la page sauf dans Magnolia
    if (inMgnl) {
      this.isSpinnerVisible = false;
    }

    document.addEventListener('ejEventHeaderLoad', this.ejEventHeaderLoadListener);
  },
  methods: {
    ...mapActions({
      actionVerifierStatutAppariement: 'casinoPrivileges/verifierStatutAppariement',
      actionObtenirCarte: 'casinoPrivileges/obtenirCarte',
      actionSauvegarderCarte: 'casinoPrivileges/sauvegarderCarte',
    }),

    verifierSessionOuverte() {
      // eslint-disable-next-line no-restricted-globals
      event.preventDefault();

      if (this.isSessionOuverte()) {
        this.verifierStatutClient();
        return true;
      }

      return false;
    },

    isSessionOuverte() {
      return session.sessionEstOuverte();
    },

    verifierStatutClient() {
      this.statutClient = '';

      if (this.isSessionOuverte()) {
        let estInvite = true;

        if (this.$store.state.profile.profileDetails) {
          estInvite = this.$store.state.profile.profileDetails.status.includes(
            playerPaymentProfileStatus.GUEST
          );
        } else {
          // au cas où le store n'est pas accessible, utiliser ejAPI (moins fiable mais fonctionne aussi)
          // eslint-disable-next-line no-undef
          estInvite = ejApi.clientEstInvite();
        }

        if (estInvite) {
          // pour ne pas voir de glitch on met le spinner visible au chargement et on le retire ici pour le client Guest
          // dans les autres cas, le spinner est retiré dans obtenirCarte
          this.isSpinnerVisible = false;
          this.statutClient = 'guest';
        } else {
          this.statutClient = 'joueur';
          this.obtenirCarte();
        }
      } else {
        this.statutClient = 'non_connecte';
      }
    },

    verifierStatutAppariement() {
      this.isSpinnerVisible = true;

      this.actionVerifierStatutAppariement()
        .then((response) => {
          if (response.data.status === 'SUCCESS') {
            this.appariementValide = true;
            if (response.data.msg === 'MSG05-30') {
              this.erreurApparimentSuccesMaisCarteInactive = true;
            }
          }
          this.isSpinnerVisible = false;
        })
        .catch((error) => {
          if (typeof error.data !== 'undefined') {
            if (error.data.msg === 'CONNEXION') {
              session.fermerSession().then(() => {
                returnToHome();
              });
            }

            if (error.data.msg === 'MSG01') {
              // on utilise consentementClient pour afficher le message d'erreur directement sur la page de consentement
              this.consentementClient = false;
              this.recupererMessage(error.data.msg);
            }

            if (error.data.msg === 'MSG05-30') {
              this.erreurApparimentSuccesMaisCarteInactive = true;
            }

            this.recupererMessage(error.data.msg);
            this.isSpinnerVisible = false;
          } else {
            this.afficherErreurServeur();
            this.isSpinnerVisible = false;
          }
        });
    },

    obtenirCarte() {
      this.isSpinnerVisible = true;
      this.actionObtenirCarte()
        .then((response) => {
          // service Reconnaissance/Points indisponible
          if (response.data.msg === 'MSG05-7') {
            this.recupererMessage(response.data.msg);
          }
          this.isSpinnerVisible = false;
        })
        .catch((error) => {
          if (typeof error.data !== 'undefined') {
            if (error.data.msg === 'CONNEXION') {
              session.fermerSession().then(() => {
                returnToHome();
              });
            }

            if (error.data.msg === 'MSG01') {
              this.afficherErreurServeur();
            }

            // Le service retourne une carte mais également un statut d'erreur tel que inactive (afficher seulement le message sans le formulaire)
            if (error.data.number) {
              this.numeroCarte = error.data.number;

              if (error.data.msg === 'MSG05-30') {
                // cas spécial plutôt que afficher avec MessageMel, on affiche un type différent de contenu pour cette erreur (carte inactive)
                this.erreurObtenirCarteInactive = true;
              } else {
                // tous les autres cas d'erreurs provenant du service ObtenirCarte
                this.erreurObtenirCarte = true;
              }
            }

            if (error.data.msg) {
              this.recupererMessage(error.data.msg);
            }
            this.isSpinnerVisible = false;
          } else {
            this.afficherErreurServeur();
            this.isSpinnerVisible = false;
          }
        });
    },

    sauvegarderCarte(numeroCarte) {
      // eslint-disable-next-line no-restricted-globals
      event.preventDefault();

      this.isSpinnerVisible = true;

      this.actionSauvegarderCarte(numeroCarte)
        .then((response) => {
          if (response.data.status === 'SUCCESS') {
            if (numeroCarte) {
              // lors du retrait ou la sauvegarde d'une carte nous savons déjà que le client a déjà passé l'étape de consentement
              this.consentementClient = true;
              // la validation de l'appariement a été faite lors de la sauvegarde donc permettre l'affichage du formulaire
              this.appariementValide = true;

              // affiche message "carte associée avec succès"
              this.recupererMessage('MSG05-1');
            } else {
              this.inputNumeroCarte = '';
              this.consentementClient = false;
              this.inputIsValid = false;
              this.retraitCarte = true;

              // affiche message "carte retirée avec succès"
              this.recupererMessage('MSG05-2');
            }
            this.compteurErreurs = 0;
          }
          this.isSpinnerVisible = false;
        })
        .catch((error) => {
          if (typeof error.data !== 'undefined') {
            if (error.data.msg === 'CONNEXION') {
              session.fermerSession().then(() => {
                returnToHome();
              });
            }

            this.compteurErreurs++;

            if (this.compteurErreurs >= this.NOMBRE_MAX_ERREURS) {
              this.recupererMessage('MSG05-40');
            } else {
              this.recupererMessage(error.data.msg);
            }
            this.isSpinnerVisible = false;
          } else {
            this.afficherErreurServeur();
            this.isSpinnerVisible = false;
          }
        });
    },

    ouvrirModaleRetraitCarte() {
      this.$bvModal.show('retrait-carte');
    },

    confirmerRetraitCarte() {
      this.fermerModaleRetraitCarte();
      this.sauvegarderCarte('');
    },

    fermerModaleRetraitCarte() {
      this.$bvModal.hide('retrait-carte');
    },

    validateFormInput(evt) {
      if (Number.isInteger(Number(this.inputNumeroCarte)) && this.inputNumeroCarte != '') {
        this.inputIsValid = true;
      } else {
        this.inputIsValid = false;

        if (this.inputNumeroCarte != '') {
          // affiche message "Oups! Vous devez entrer uniquement des chiffres."
          this.recupererMessage('MSG05-3');
        }
      }
    },

    viderMessageMel() {
      this.contentMessageMel.message = '';
    },

    redirectToValidation() {
      this.$router.push(PageMapping.IDENTITE_REPRISE.siteUrl).catch(() => {
        console.error(`Route inexistante`);
      });
    },

    recupererMessage(codeMessage) {
      MessageHelpers.obtenirMessage(codeMessage, this.$root)
        .then((msgResp) => {
          this.contentMessageMel.msgType = msgResp.msgType;

          if (this.numeroCarte) {
            this.contentMessageMel.message = this.jel_replaceTokens(msgResp.msgDetail);
          } else {
            // normalement le message d'erreur contient un numéro de carte provenant du store mais comme la valeur
            // du store n'est pas encore définie on la remplace par le numéro saisi dans le formulaire.
            const tempMessage = msgResp.msgDetail.replace(
              '{{casinoPrivileges.numeroCarte}}',
              this.inputNumeroCarte
            );
            this.contentMessageMel.message = this.jel_replaceTokens(tempMessage);
          }
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
    },

    consentir() {
      this.retraitCarte = false;
      this.consentementClient = true;
      this.viderMessageMel();
      this.verifierStatutAppariement();
    },

    afficherErreurServeur() {
      MessageHelpers.obtenirMessage('MSG01', this.$root)
        .then((msgResp) => {
          this.contentMessageMel.message = msgResp.msgDetail;
        })
        .catch((error) => {
          console.error('Erreur de récupération du message!', error);
        });
      this.isErreurServeur = true;
    },

    erreurServerReessayer() {
      this.isErreurServeur = false;
      this.verifierSessionOuverte();
    },

    ejEventHeaderLoadListener() {
      // une fois la barre PCU chargée, on vérifie le statut du client
      this.verifierSessionOuverte();
      document.removeEventListener('ejEventHeaderLoad', this.ejEventHeaderLoadListener);
    },
  },
};
</script>

<style lang="scss">
/* non scoped utilisé pour overwriter le style des boutons par défaut de la modale */
/* pour la modale on ne pouvait utiliser un v-deep comme le contenu se charge en sibling */
.titre-modal {
  font-family: graphik_semibold !important;
  font-size: calc(1.25rem + 0.3333333333vw) !important;
  line-height: calc(1.4375rem + 0.5833333333vw) !important;
}

.contenu-texte-modal {
  line-height: 20px;
}

.btn-modal-confirm {
  min-height: 52px;
}

.btn-modal-cancel {
  color: #0a3159;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #a6ecfe;
  font-family: 'graphik_medium';
  border: none;
  background: transparent;
}
</style>

<style lang="scss" scoped>
.compteClair button.btn.btn-primaire,
.compteClair button.btn.btn-primaire:disabled {
  color: $couleur-secondaire;
}

#numeroCarte {
  max-width: 135px;
  display: inline-block;
}

.fin-numero-carte {
  font-weight: bold;
}

.txtNumeroCarte {
  font-family: graphik_bold;
  color: $couleur-bleu-fonce-lq;
  font-size: 16px;
  display: inline-block;
}

.retraitCarte {
  text-decoration: underline;
  cursor: pointer;
  color: $couleur-primaire;
}

.texte-legal {
  font-size: 13px;
  line-height: 17px;
  color: $couleur-bleu-fonce-lq;
}

/* Classe bootstrap d-inline-block remplacée par ceci car le !important ajouté par bootstrap entre en conflit avec le v-show */
.mel-erreur,
.mel-succes,
.mel-avertissement,
.mel-info {
  display: inline-block;
}

.lien-retour:hover {
  text-decoration: none;
}

.icone-fleche {
  margin-right: 4px;
}

.section-points {
  max-width: 400px;
}

.zone-pts {
  background-color: #e9f6fe;
  border-radius: 11px;
  opacity: 1;
  font-variant-numeric: tabular-nums;
}

.absolute-bottom {
  position: absolute;
  bottom: 0;
}

::v-deep .mel-avertissement,
.message-succes {
  display: block !important;
}
</style>
